import { createAsyncAction } from 'redux-promise-middleware-actions';

import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

export const generalCategoriesConstants = {
    GENERAL_CATEGORIES_LOADED: 'GENERAL_CATEGORIES_LOADED',
    GENERAL_CATEGORY_CREATED: 'GENERAL_CATEGORY_CREATED',
    GENERAL_CATEGORY_UPDATED: 'GENERAL_CATEGORY_UPDATED',
    GENERAL_CATEGORY_DELETED: 'GENERAL_CATEGORY_DELETED'
};

export const generalCategoriesFulfilledConstants = getActionTypesResult(generalCategoriesConstants, '_FULFILLED');

export const generalCategoriesRejectedConstants = getActionTypesResult(generalCategoriesConstants, '_REJECTED');

export const generalCategoriesPendingConstants = getActionTypesResult(generalCategoriesConstants, '_PENDING');

export const fetchGeneralCategories = createAsyncAction(generalCategoriesConstants.GENERAL_CATEGORIES_LOADED, () =>
    api.get(`deviceCategories/getCategories`).then(res => res.data)
);

export const saveGeneralCategory = createAsyncAction(
    generalCategoriesConstants.GENERAL_CATEGORY_CREATED,
    generalCategory => api.post('deviceCategories', generalCategory).then(res => res.data)
);

export const updateGeneralCategory = createAsyncAction(
    generalCategoriesConstants.GENERAL_CATEGORY_UPDATED,
    (generalCategoryId, generalCategory) =>
        api.put(`deviceCategories/${generalCategoryId}`, generalCategory).then(res => res.data)
);

export const deleteGeneralCategory = createAsyncAction(
    generalCategoriesConstants.GENERAL_CATEGORY_DELETED,
    generalCategory => api.delete(`deviceCategories/${generalCategory.id}`).then(() => generalCategory.id)
);
